export function getStateKeyByValue<T>(stateObj: Record<number, string>, value: string) {
  return Number(
    Object.keys(stateObj).find((key) => {
      const keyNum = Number(key);
      return stateObj[keyNum] === value;
    }),
  ) as T;
}
